import { render, staticRenderFns } from "./MaterialComparison.vue?vue&type=template&id=55e06c56&scoped=true&"
import script from "./MaterialComparison.vue?vue&type=script&lang=js&"
export * from "./MaterialComparison.vue?vue&type=script&lang=js&"
import style0 from "./MaterialComparison.vue?vue&type=style&index=0&id=55e06c56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e06c56",
  null
  
)

export default component.exports